import React, {Component} from 'react';
import {Link} from 'react-router';
import classNames from 'classnames';

import MakeContentScroll from '../components/branded_content/make_content_scroll';
import MakeContent from '../components/branded_content/make_content';
import ContentIsCreatedNotCurated from '../components/branded_content/content_is_created_not_curated';
import EpicContentCreators from '../components/branded_content/epic_content_creators';
import ContentNoLimits from '../components/branded_content/content_no_limits';
import EndlessPossibilities from '../components/endless_possibilities/';
import MeetTheTeam from '../components/meet_the_team/';
import ContactForm from '../components/contact_form';

export default class BrandedContent extends Component {
    constructor(){
        super();
        this.adjustWindowSizeState = this.adjustWindowSizeState.bind(this);
        this.setInnerHeight = this.setInnerHeight.bind(this);
        this.setInnerPageWidth = this.setInnerPageWidth.bind(this);
        this.setIsMobile = this.setIsMobile.bind(this);
        this.setDisplayMode = this.setDisplayMode.bind(this);
        this.displayMakeContentScroll = this.displayMakeContentScroll.bind(this);
        this.displayGetStartedButton = this.displayGetStartedButton.bind(this);
        this.displayDownArrow = this.displayDownArrow.bind(this);
        this.setContentContainerOffset = this.setContentContainerOffset.bind(this);
        this.returnContentContainerStyle = this.returnContentContainerStyle.bind(this);
        this.returnBrandedContentHeroStyle = this.returnBrandedContentHeroStyle.bind(this);
        this.state = {
            isMobile: false,
            displayStatic: false,
            containerOffset: null,
            innerHeight: '100vh',
            innerPageWidth: null
        }
    }

    componentDidMount(){
        this.setInnerHeight();
        this.setInnerPageWidth();
        this.setIsMobile();
        this.setDisplayMode();

        window.addEventListener('resize', this.adjustWindowSizeState);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.adjustWindowSizeState);
    }

    adjustWindowSizeState(){
        this.setIsMobile();
        this.setInnerPageWidth();
    }

    setInnerHeight(){
        const innerHeight = window.innerHeight;

        this.setState({
            innerHeight: `${innerHeight}px`
        });
    }

    setInnerPageWidth(){
        const innerPageWidth = window.innerWidth;

        this.setState({
            innerPageWidth
        });
    }

    setIsMobile(){
        // 769 is is the sm breakpoint defined by our gridle state
        const isMobile = window.innerWidth < 769;

        this.setState({
            isMobile
        });
    }

    setDisplayMode(){
        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        this.setState({
            displayStatic: isIE
        });
    }

    displayMakeContentScroll(){
        const {isMobile, displayStatic, containerOffset, innerHeight} = this.state;

        return (isMobile || displayStatic) ? (
            <MakeContent
                innerHeight={innerHeight}
                displayStatic={displayStatic}
            />
        ) : (
            <MakeContentScroll
                containerOffset={containerOffset}
                setContentContainerOffset={this.setContentContainerOffset} />
        );
    }

    displayGetStartedButton(){
        const {isMobile, displayStatic} = this.state;

        return (displayStatic && !isMobile) ? null : (
            <a href='#contact-form'>
                <button>Get Started</button>
            </a>
        );
    }

    displayDownArrow(){
        const {isMobile, displayStatic} = this.state;

        return (displayStatic && !isMobile) ? null : (
            <div className='down-arrow-white'></div>
        );
    }

    setContentContainerOffset(offset){
        this.setState({
            containerOffset: offset
        });
    }

    returnContentContainerStyle(){
        const {isMobile, displayStatic, containerOffset} = this.state;

        if(isMobile || displayStatic || !containerOffset){
            return null;
        } else {
            return {
                position: 'relative',
                top: containerOffset
            };
        }
    }

    returnBrandedContentHeroStyle(){
        const {isMobile, innerHeight} = this.state;

        if(isMobile){
            return {
                height: innerHeight
            }
        } else {
            return null;
        }
    }

    render(){
        const {isMobile, displayStatic, innerPageWidth} = this.state;
        const snWhiteLogo = require('images/sn_logo_white.png');
        const snBlackLogo = require('images/sn_logo_black.png');
        const brandedContentHeroStyle = this.returnBrandedContentHeroStyle();
        const brandedContentContainerStyle = this.returnContentContainerStyle();
        const brandedContentHeroTextClassnames = classNames('gr-5', 'branded-content-hero-text', {
            'push-5': displayStatic,
            'push-7': !displayStatic
        });
        const GetStartedButton = this.displayGetStartedButton();
        const DownArrow = this.displayDownArrow();
        const MakeContentScroll = this.displayMakeContentScroll();

        return(
            <div id='branded-content'>
                <div className='container'>
                    <div className='hide show@xs creator-banner-mobile'>
                        <span>Are you a creator?</span>
                        <Link to='/content_creator'>
                            <button>Click Here</button>
                        </Link>
                    </div>
                    <div className='show hide@xs gr-12 nav-filter'></div>
                    <div className='gr-12 branded-content-nav'>
                        <Link to='/'>
                            <img
                                src={snWhiteLogo}
                                className='hide hide@xs sn-logo' />
                            <img
                                src={snBlackLogo}
                                className='show show@xs sn-logo' />
                        </Link>

                        <Link to="/content_creator" className="hide show@sm content-creator-link-nav" />
                        <div id="are-you-a-content-creator" className="hide show@sm">
                            <div>
                                <span>Are you a</span>
                                <br/>
                                <span>Content Creator?</span>
                            </div>
                        </div>
                    </div>

                    <div
                        className='gr-12 branded-content-hero'
                        style={brandedContentHeroStyle}>
                        <div className={brandedContentHeroTextClassnames}>
                            <p>High performing</p>
                            <p className='text-emphasis'>branded content</p>
                            <p>is just a click away</p>
                        </div>

                        {GetStartedButton}

                        {DownArrow}
                    </div>

                    {MakeContentScroll}

                    <div
                        className='branded-content-container'
                        style={brandedContentContainerStyle}>
                        <ContentIsCreatedNotCurated />
                        <EpicContentCreators displayStatic={displayStatic} />
                        <ContentNoLimits isMobile={isMobile} pageWidth={innerPageWidth} />
                        <EndlessPossibilities displayStatic={displayStatic} page={'branded-content'} />
                        <MeetTheTeam isMobile={isMobile} displayStatic={displayStatic} page={'branded-content'} />
                        <ContactForm displayStatic={displayStatic} page={'branded-content'} />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/branded_content.js